import * as UtilitiesActions from './../actions/utilities.actions';
import { initialUtilitiesState, IUtilitiesState } from '../../state/utilities.state';


export function UtilitiesReducer(state = initialUtilitiesState, action: UtilitiesActions.UtilitiesActions): IUtilitiesState {
    switch (action.type) {
        case UtilitiesActions.GET_COUNTRY_LIST_SUCCESS: return {
            ...state,
            countries: action.payload
        };
        case UtilitiesActions.GET_TAX_RATE_SCHEDULE_LIST_SUCCESS: return {
            ...state,
            taxRateSchedule: action.payload
        };
        default: {
            return state;
        }
    }
}
